import React, { useEffect } from "react";
import * as yup from 'yup';
import { useForm, Controller } from "react-hook-form";
import { connect } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { updateBrandData } from "../ReduxToolkit/Reducers/brands";
import { updateRetailer } from "../ReduxToolkit/Reducers/retailers";

const schema = yup.object().shape({
  name: yup.string().required('Name is required').min(2, 'Name must be at least 2 characters')
});

const EditEntityNameModal = ({ type, name, entityId, open, onClose, updateBrandData, updateRetailer, onSuccess }) => {
  const { control, reset, handleSubmit, formState: { isSubmitting, errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: name || ''
    }
  });

  useEffect(() => {
    if (open) reset({ name: name })
  }, [open])

  const onSubmit = async (values) => {
    try {
      const data = {
        id: entityId,
        features: {
          name: values.name
        }
      };

      if (type === 'brand') {
        await updateBrandData({
          data,
          cb: () => {
            if (onSuccess) onSuccess();
            onClose();
          }
        });
      } else if (type === 'retailer') {
        await updateRetailer({
          data,
          cb: () => {
            if (onSuccess) onSuccess();
            onClose();
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getModalTitle = () => {
    if (type === 'brand') return 'Edit Brand Name';
    if (type === 'retailer') return 'Edit Retailer Name';
    return 'Edit Name';
  };

  const getEntityLabel = () => {
    if (type === 'brand') return 'Brand Name';
    if (type === 'retailer') return 'Retailer Name';
    return 'Name';
  };

  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: "18px", fontWeight: "700" }}>
          {getModalTitle()}
        </span>
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>{getEntityLabel()} *</Label>
          <Controller
            name="name"
            control={control}
            render={({ field: { value, onChange } }) => {
              console.log(value)
              return (
                <Input
                  value={value}
                  onChange={onChange}
                  invalid={!!errors?.name}
                  placeholder={`Enter ${type} name`}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSubmit(onSubmit)();
                    }
                  }}
                />
              )
            }}
          />
          {errors?.name && (
            <FormFeedback>{errors.name.message}</FormFeedback>
          )}
        </FormGroup>
      </ModalBody>
      <ModalFooter>

        <Button
          color="primary"
          className="rounded-pill"
          onClick={handleSubmit(onSubmit)}
          type='submit'
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Spinner size="sm" color="light" />
          ) : (
            "Save"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapDispatchToProps = {
  updateBrandData,
  updateRetailer,
};

export default connect(null, mapDispatchToProps)(EditEntityNameModal);
